import { render, staticRenderFns } from "./Creatfile.vue?vue&type=template&id=68c03ba8&scoped=true&"
import script from "./Creatfile.vue?vue&type=script&lang=js&"
export * from "./Creatfile.vue?vue&type=script&lang=js&"
import style0 from "./Creatfile.vue?vue&type=style&index=0&id=68c03ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c03ba8",
  null
  
)

export default component.exports